import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getNodeInSelection = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  return node;
});
export {
  getNodeInSelection
};
//# sourceMappingURL=get-node-in-selection.js.map
